export const warehouseLeadRoute = {
  base: '/warehouse-lead',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const warehouseLeadRouteVehicles = {
  vehicles: `${warehouseLeadRoute.base}${warehouseLeadRoute.vehicles}`,
};

export const warehouseLeadRouteTrucks = {
  trucks: `${warehouseLeadRoute.base}${warehouseLeadRoute.vehicles}${warehouseLeadRoute.trucks}`,
};

export const warehouseLeadRouteEquipments = {
  equipments: `${warehouseLeadRoute.base}${warehouseLeadRoute.vehicles}${warehouseLeadRoute.equipments}`,
};

export const warehouseLeadRouteTrailers = {
  trailers: `${warehouseLeadRoute.base}${warehouseLeadRoute.vehicles}${warehouseLeadRoute.trailers}`,
};

export const warehouseLeadRouteVendors = {
  vendors: `${warehouseLeadRoute.base}${warehouseLeadRoute.vendors}`,
  detailVendor: `${warehouseLeadRoute.base}${warehouseLeadRoute.vendors}${warehouseLeadRoute.commonDetail}`,
};

export const warehouseLeadRoutePurchaseOrder = {
  purchaseOrder: `${warehouseLeadRoute.base}${warehouseLeadRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const warehouseLeadRouteOrder = {
  order: `${warehouseLeadRoute.base}${warehouseLeadRoute.order}`,
  detailOrder: (orderId: string) => `${warehouseLeadRoute.base}${warehouseLeadRoute.order}/${orderId}`,
  updateOrder: (orderId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.order}/${orderId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteCrm = {
  crm: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}`,
  leads: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}`,
  createLead: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}${warehouseLeadRoute.commonCreate}`,
  detailLead: (leadId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}/${leadId}${warehouseLeadRoute.commonEdit}`,
  clients: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}`,
  createClient: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}${warehouseLeadRoute.commonCreate}`,
  detailClient: (clientId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}/${clientId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteQuote = {
  quotes: `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}`,
  createQuotes: `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}${warehouseLeadRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}/${quoteId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteInventory = {
  inventories: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}`,
  inventory: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}`,
  createInventory: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}${warehouseLeadRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}/${inventoryId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRoutePackage = {
  package: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}`,
  createPackage: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}${warehouseLeadRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}/${packageId}${warehouseLeadRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}/${packageId}${warehouseLeadRoute.commonClone}`,
};

export const warehouseLeadRouteUser = {
  users: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}`,
  createUser: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}${warehouseLeadRoute.commonCreate}`,
  detailUser: (userId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}/${userId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteVenue = {
  venue: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}`,
  createVenue: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}${warehouseLeadRoute.commonCreate}`,
  detailVenue: (venueId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}/${venueId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteInvoice = {
  invoices: `${warehouseLeadRoute.base}${warehouseLeadRoute.invoice}`,
  createInvoice: `${warehouseLeadRoute.base}${warehouseLeadRoute.invoice}${warehouseLeadRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.invoice}/${invoiceId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteRoleManagement = {
  roleManagement: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.roleManagement}`,
  createRole: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.roleManagement}${warehouseLeadRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.roleManagement}/${roleId}${warehouseLeadRoute.commonEdit}`,
};

export const warehouseLeadRouteRoleCoupon = {
  coupon: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.coupon}`,
};

export const warehouseLeadRouteRoleEventType = {
  eventType: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.eventType}`,
};

export const warehouseLeadRouteRoleCategory = {
  category: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.category}`,
};

export const warehouseLeadRouteRoleChecklist = {
  checklist: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.checklist}`,
};

export const warehouseLeadRouteJob = {
  jobs: `${warehouseLeadRoute.base}${warehouseLeadRoute.jobs}`,
  detailJob: (jobId: string) => `${warehouseLeadRoute.base}${warehouseLeadRoute.jobs}/${jobId}`,
};

export const warehouseLeadRouteQuarantine = {
  quarantine: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.quarantines}`,
};

export const warehouseLeadRouteTask = {
  task: `${warehouseLeadRoute.base}${warehouseLeadRoute.task}`,
};

export const warehouseLeadRouteGlobal = {
  global: `${warehouseLeadRoute.base}${warehouseLeadRoute.global}`,
};

export const warehouseLeadRouteReport = {
  reports: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}`,
  overbookingItem: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.overbookingItem}`,
  subrentalsReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.subrentalsReport}`,
  clientIncomeReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.clientIncomeReport}`,
  revenueReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.revenueReport}`,
  geographicRevenueReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.quoteRevenueReport}`,
  orderRevenueReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.orderRevenueReport}`,
  cancellationReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.cancellationReport}`,
  deliveryReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.deliveryReport}`,
  taskCompletionReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.taskCompletionReport}`,
  discountUsageReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.discountUsageReport}`,
  featureUtilizationReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.featureUtilizationReport}`,
  jobCostingReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.jobCostingReport}`,
  inventoryUsageReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.inventoryUsageReport}`,
  quarantineReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.quarantineReport}`,
  foremanTaskReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.foremanTaskReport}`,
  marketingRevenueReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.marketingRevenueReport}`,
  financialOrderReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.financialOrderReport}`,
  transactionSummaryReport: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.transactionSummaryReport}`,
};

export const warehouseLeadRouteAbsolute = {
  // Dashboard
  dashboard: warehouseLeadRoute.base,

  // Communication
  communication: `${warehouseLeadRoute.base}${warehouseLeadRoute.communication}`,

  // Settings
  settings: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}`,

  // Schedule
  schedule: `${warehouseLeadRoute.base}${warehouseLeadRoute.schedule}`,

  ...warehouseLeadRouteVehicles,
  ...warehouseLeadRouteTrucks,
  ...warehouseLeadRouteEquipments,
  ...warehouseLeadRouteTrailers,
  ...warehouseLeadRouteVendors,
  ...warehouseLeadRoutePurchaseOrder,
  ...warehouseLeadRouteOrder,
  ...warehouseLeadRouteCrm,
  ...warehouseLeadRouteQuote,
  ...warehouseLeadRouteInventory,
  ...warehouseLeadRoutePackage,
  ...warehouseLeadRouteUser,
  ...warehouseLeadRouteVenue,
  ...warehouseLeadRouteRoleManagement,
  ...warehouseLeadRouteRoleCoupon,
  ...warehouseLeadRouteRoleEventType,
  ...warehouseLeadRouteRoleCategory,
  ...warehouseLeadRouteRoleChecklist,
  ...warehouseLeadRouteJob,
  ...warehouseLeadRouteQuarantine,
  ...warehouseLeadRouteInvoice,
  ...warehouseLeadRouteReport,
  ...warehouseLeadRouteTask,
  ...warehouseLeadRouteGlobal,
};
